import axios from 'axios';
import qs from 'qs';

import { CONTEXT_PATH } from '@constants/serviceConstants';
import { getEnv } from '@lib/utils';

const isLocal = () => {
  return window.location.hostname.includes('local');
};

const header = {
  'Content-Type': 'application/json',
};

const getBaseUrl = () => {
  return isLocal() ? '' : getEnv().API_URL;
};

const axiosInstance = axios.create({
  baseURL: getBaseUrl() + CONTEXT_PATH,
  headers: header,
  paramsSerializer: (params) => {
    return qs.stringify(params);
  },
});

export const setAxiosToken = (token) => {
  sessionStorage.setItem('Authorization', token);
};

axiosInstance.interceptors.request.use((request) => {
  request.headers.Authorization = sessionStorage.getItem('Authorization') || '';

  if (_.isEmpty(request.data)) {
    request.data = null;
  }
  return request;
});

axiosInstance.interceptors.response.use(
  (response) => {
    const { responseURL } = response.request;
    const { authorization } = response.headers;

    const domain = isLocal() ? origin : getEnv().API_URL;

    if (!_.isEmpty(authorization)) {
      if (responseURL.replace(domain, '') === '/csp/auth' || responseURL.replace(domain, '') === '/csp/auth/kakao') {
        setAxiosToken(authorization);
      }
    }
    return response.data.resultData;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
